module.exports = __webpack_public_path__ + "media/images/landing/illust/article-bg-1-425ec18051f375522f346ea4c2439405.jpg";